import { render, staticRenderFns } from "./HeaderAnalyses.vue?vue&type=template&id=9836f594&"
import script from "./HeaderAnalyses.vue?vue&type=script&setup=true&lang=ts&"
export * from "./HeaderAnalyses.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9836f594')) {
      api.createRecord('9836f594', component.options)
    } else {
      api.reload('9836f594', component.options)
    }
    module.hot.accept("./HeaderAnalyses.vue?vue&type=template&id=9836f594&", function () {
      api.rerender('9836f594', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/core-layout/components/CoreHeader/components/HeaderAnalyses.vue"
export default component.exports